import Cookies from 'js-cookie';

const TokenKey = 'paysharp_client_access_token';
const RefreshKey = 'paysharp_client_refresh_token';
const AccountIndex = 'paysharp_account_index';
const activeModel = 'paysharp_active_model';
const LoginTypeIdKey = 'paysharp_client_login_typeid';
const TempTokenKey = 'paysharp_client_temp_token';
const ProductList = 'paysharp_product_list';

export function getAccessToken() {
  return Cookies.get(TokenKey);
  //return localStorage.getItem(TokenKey);
}

export function getTempToken() {
  return Cookies.get(TempTokenKey);
  //return localStorage.getItem(TempTokenKey);
}
export function setTempToken(token) {
  return Cookies.set(TempTokenKey, token, { secure: true, sameSite: 'strict' });
  //return localStorage.setItem(TempTokenKey, token);
}

export function getLoginTypeId() {
  return Cookies.get(LoginTypeIdKey);
  //return localStorage.getItem(LoginTypeIdKey);
}
export function setLoginTypeId(token) {
  return Cookies.set(LoginTypeIdKey, token, { secure: true, sameSite: 'strict' });
  //return localStorage.setItem(LoginTypeIdKey, token);
}

export function setAccessToken(token) {
  return Cookies.set(TokenKey, token, { secure: true, sameSite: 'strict' });
  //return localStorage.setItem(TokenKey, token);
}

export function setAccountIndex(accountIndex) {
  return Cookies.set(AccountIndex, accountIndex, { secure: true, sameSite: 'strict' });
  //return localStorage.setItem(AccountIndex, accountIndex);
}

export function setActiveModel(activeModelCode) {
  return Cookies.set(activeModel, activeModelCode, { secure: true, sameSite: 'strict' });
  
  //return localStorage.setItem(activeModel, activeModelCode);
}

export function setProductList(productList) {
  return Cookies.set(ProductList, productList, { secure: true,  sameSite: 'strict' });
  //return localStorage.setItem(ProductList, productList);
}
export function getProductList() {
  return Cookies.get(ProductList);
  //return localStorage.getItem(ProductList);
}


export function getActiveModel() {
  return Cookies.get(activeModel);
  //return localStorage.getItem(activeModel);
}
export function getAccountIndex() {
 return Cookies.get(AccountIndex);
  //return localStorage.getItem(AccountIndex);
}
export function removeActiveModel() {
  return Cookies.remove(activeModel);
  //return localStorage.removeItem(activeModel);
}
export function removeAccountIndex() {
  return Cookies.remove(AccountIndex);
  //return localStorage.removeItem(AccountIndex);
}

export function removeAccessToken() {
  return Cookies.remove(TokenKey);
  //return localStorage.removeItem(TokenKey);
}

export function removeTempToken() {
  return Cookies.remove(TempTokenKey);
  //return localStorage.removeItem(TempTokenKey);
}

export function removeLoginTypeId() {
  return Cookies.remove(LoginTypeIdKey);
  //return localStorage.removeItem(LoginTypeIdKey);
}
export function removeProductList() {
  return Cookies.remove(ProductList);
  //return localStorage.removeItem(ProductList);
}

// export function getRefreshToken() {
//   return Cookies.get(RefreshKey);
// }

// export function setRefreshToken(token) {
//   return Cookies.set(RefreshKey, token);
// }

// export function removeRefreshToken() {
//   return Cookies.remove(RefreshKey);
// }
